// eslint-disable-next-line no-restricted-imports -- This is the canonical source for typed Redux hooks.
import { useDispatch, useSelector } from 'react-redux';
export const useAppDispatch = useDispatch.withTypes();
export const useAppSelector = useSelector.withTypes();
